
import React from 'react';
import { parseAndFormatCurrency } from 'shared/utils/currency';
import { range } from 'shared/utils/numbers';
import { CartItemFragment, useRemoveItemMutation, useUpdateItemMutation } from '../../generated.graphql';
import { formatCondition } from './condition';

interface UseItemConfig {
  item: CartItemFragment
  readonly: boolean
}

export const useItem = (config: UseItemConfig) => {
  const { item, readonly = false } = config;

  const [removeResult, removeMutation] = useRemoveItemMutation();
  const [updateResult, updateMutation] = useUpdateItemMutation();

  const maxQty = item.maxQty || 10

  return {

    isRemoving: removeResult.fetching,
    isUpdating: updateResult.fetching,
    style: {opacity: removeResult.fetching ? 0.5 : undefined},

    // Converts the UPPERCASE enum to Title Case New or Preloved
    formattedCondition: formatCondition(item.condition),

    // The existing Corp sites prepend the name with "Pre-loved "
    // Since we are showing that separately, strip it out
    // This will be redundant if/when that code is removed from the Corp sites
    formattedName: item.title.replace(/^Pre-loved /, ''),

    formattedRate: parseAndFormatCurrency(item.qty * parseFloat(item.selectedRate.rentalMonthly)),

    QtySelect: (props: {className?: string, children?: React.ReactChild}) => (
      (readonly === false && maxQty > 1) ?
        <select 
          value={item.qty} 
          className={props.className}
          onChange={e => {
            updateMutation({input: {
              id: item.id, 
              qty: parseInt(e.currentTarget.value)
            }})
          }} 
        >
          {range(1, maxQty).map(q => <option value={q} key={q}>{q}</option>)}
        </select>
        :
        <>{props.children ?? item.qty}</>
    ),

    remove: async () => await removeMutation({input: {id: item.id}}),
  }
}
